
import { Component, Vue, Prop, Emit, Ref } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { DeviceControllerOutput } from "@/store/site-monitor-cameras/types";
import { renderDistance } from "@/filters";
import { EventDetails } from '@/store/site-monitor/types';

const SMCameras = namespace("siteMonitorCameras");
const SiteMonitor = namespace("siteMonitor");

@Component({
	filters: {
		renderDistance
	}
})
export default class ControlDevicesList extends Vue {
	@SiteMonitor.Getter("getEventDetails") getEventDetails: EventDetails;

	@SMCameras.Action fetchAreaOutputs: (params: { groupID: number, pageNumber: number, paginated: boolean }) => Promise<void>;
	@SMCameras.State("areaOutputCount") public areaOutputCount: number;

	@Prop() outputs!: DeviceControllerOutput[];
	@Prop() title!: string;
	@Prop({ default: false, type: Boolean }) isAreaOutputs!: boolean;

	private openOutputs: boolean = false;
	private pageNumber: number = 1;

	@Emit("doPulseOutput")
	private async emitPulse(output: DeviceControllerOutput): Promise<DeviceControllerOutput> {
		return output;
	}

	private setOutput(output: DeviceControllerOutput, on: boolean): void  {
		this.$emit("setOutput", output, on);
	}

	private pulseOutput(output: DeviceControllerOutput): void  {
		output.controlRequest = true;

		this.$nextTick(() => {
			const refKey = `reason-${output.objectId}`;
			let textArea = this.$refs[refKey];

			// If no ref found, just exit
			if (!textArea) {
				return;
			}

			if (Array.isArray(textArea)) {
				textArea = textArea[0];

				// If its an empty array, just exit
				if (!textArea) {
					return;
				}
			}

			if (textArea instanceof HTMLTextAreaElement) {
				textArea.focus();
			}
		});
	}

	private cancelPulse(output: DeviceControllerOutput): void  {
		output.controlRequest = false;
		output.controlReason = "";
	}

	private get showLoadMoreButton(): boolean {
		return this.isAreaOutputs && this.outputs && this.outputs.length < this.areaOutputCount;
	}

	private showMoreOutputs(): void {
		if (!this.isAreaOutputs) {
            return;
        }

		this.pageNumber++;
		this.fetchAreaOutputs({ groupID: this.getEventDetails.groupID, pageNumber: this.pageNumber, paginated: true });
	}

	public collapseOutputSections(): void {
		this.openOutputs = false;
	}
}

